import { Box, Button } from "@mui/material";
import styled from "styled-components";
import NavLinks from "./NavLinks";

type NavDrawerContentProps = {
  toggleDrawer: () => void;
  languageSwitch: (ln: string) => void;
};

const NavDrawerContent = ({
  toggleDrawer,
  languageSwitch,
}: NavDrawerContentProps) => {
  return (
    <>
      <DrawerContent role="presentation">
        <Box padding={3} marginTop={3} marginBottom={2}>
          <NavLinks toggleDrawer={toggleDrawer} />

          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"flex-start"}
            marginTop={2}
            gap={6}
          >
            <Button
              onClick={() => languageSwitch("nl")}
              sx={{ padding: 0, minWidth: 0 }}
            >
              <img
                src={require("../../assets/images/nl.png")}
                height="30"
                width="30"
                alt="Dutch"
              />
            </Button>
            <Button
              onClick={() => languageSwitch("en")}
              sx={{ padding: 0, minWidth: 0 }}
            >
              <img
                src={require("../../assets/images/en.png")}
                height="30"
                width="30"
                alt="English"
              />
            </Button>
          </Box>
        </Box>
      </DrawerContent>
    </>
  );
};

const DrawerContent = styled(Box)`
  width: 70vw;
`;

export default NavDrawerContent;
